// `/app/notas-fiscais` (WEB-125, `spec/28-nfse.md` §4.7). Só leitura: lista as notas
// emitidas e leva ao download (302 para URL pré-assinada). Sem step-up, sem toggle de modo.

import { useInfiniteQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { NfseScreen } from '../features/nfse/nfse-screen.tsx';
import { nfseQueryOptions } from '../features/nfse/queries.ts';

function NotasFiscais() {
  const list = useInfiniteQuery(nfseQueryOptions());
  const rows = list.data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <NfseScreen
      rows={rows}
      isLoading={list.isPending}
      error={list.error}
      onRetry={() => {
        void list.refetch();
      }}
      hasMore={list.hasNextPage}
      isLoadingMore={list.isFetchingNextPage}
      onLoadMore={() => {
        void list.fetchNextPage();
      }}
    />
  );
}

export const Route = createFileRoute('/app/notas-fiscais')({ component: NotasFiscais });
